import {BaseLinkParams} from "../../../infrastructure/models/link/base-link-params";

export class AccumulatorLinkParams extends BaseLinkParams  {}